export default "__VITE_ASSET__BaJVfylT__"